/*
 * @Author: XuXin 2172438065@qq.com
 * @Date: 2024-06-21 08:35:00
 * @LastEditors: XuXin 2172438065@qq.com
 * @LastEditTime: 2024-09-10 17:13:22
 * @FilePath: \high-tech-materialsd:\workCode\xx\youbi\front\CustPC\src\api\share\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Created by rubin on 2020/6/26.
 */

"use strict";

import http from "../../utils/http";

let shareService = {
  getShareDetail: function(data, resolve, reject) {
    http({
      url: "/PanMemberShare/getUserShareGenerFiles",
      data: data,
      method: "post",
    }).then((res) => resolve(res));
  },
  createShare: function(data, resolve, reject) {
    http({
      url: "/PanMemberShare/userFileShare",
      data: data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  cancelShare: function(data, resolve, reject) {
    http({
      url: "/PanMemberShare/userFileShareDel",
      data: data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  checkShareCode: function(data, resolve) {
    http({
      url: "/PanMemberShare/shareVerify",
      data: data,
      method: "post",
    }).then((res) => resolve(res));
  },
  getShareFiles: function(data, resolve) {
    http({
      url: "/resources/getmemberFileListNoP",
      data: data,
      method: "post",
    }).then((res) => resolve(res));
  },
  saveShareFiles: function(data, resolve) {
    http({
      url: "/PanMemberShare/saveShareFiles",
      data: data,
      method: "post",
    }).then((res) => resolve(res));
  },
  getShares: function(data, resolve, reject) {
    http({
      url: "/PanMemberShare/getuserFileShareInfo",
      data,
      method: "post",
    })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  },
  getSimpleShareDetail: function(data, resolve) {
    http({
      url: "/PanMemberShare/shareAddress",
      data: data,
      method: "post",
    }).then((res) => resolve(res));
  },
};

export default shareService;
